import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Client, Message, StompSubscription } from '@stomp/stompjs'; // Removed Stomp from here as Client is the modern way
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { ChatMessage } from '../models/chat-message.model';
import { Auth } from '@angular/fire/auth';

@Injectable({
  providedIn: 'root'
})
export class AiStudioService {

  private stompClient: Client | null = null;
  private messageSubject = new Subject<ChatMessage>();
  public messages$: Observable<ChatMessage> = this.messageSubject.asObservable();
  private connectionStateSubject = new BehaviorSubject<boolean>(false);
  public isConnected$: Observable<boolean> = this.connectionStateSubject.asObservable();
  private subscription: StompSubscription | null = null;

  private apiUrl = `${environment.restApiUrl}chat`;

  constructor(private http: HttpClient) {}

  sendAPIMessage(message: ChatMessage): Observable<ChatMessage> {
    const url = `${this.apiUrl}`;
    return this.http.post<ChatMessage>(url, message);
  }


}
